import {
	Pipe,
	PipeTransform,
} from '@angular/core';

import { upperFirst } from 'lodash';

import { CommonNAFormatter } from './na_formatter.pipe';
import { CommonNAToBlankFormatter } from './na_blank_formatter.pipe';
import { commonUtilitiesCoreService } from '../services/core.service';
import { CommonServerDateService } from '../services/server_date.service';

export interface ICommonDateFormats {
	Short: string;
	Medium: string;
	Long: string;
	Time: string;
	ShortWithTime: string;
	MediumWithTime: string;
	TimeWithMedium: string;
}

@Pipe({
	name: 'commonDateFormatter',
})
export class CommonDateFormatter implements PipeTransform {
	private formats: ICommonDateFormats = {
		Short: this.commonServerDateService.shortDateFormat,
		Medium: this.commonServerDateService.mediumDateFormat,
		Long: this.commonServerDateService.longDateFormat,
		Time: this.commonServerDateService.displayTimeFormat,
		ShortWithTime: this.commonServerDateService.shortWithTime,
		MediumWithTime: this.commonServerDateService.mediumWithTime,
		TimeWithMedium: this.commonServerDateService.timeWithMedium,
	};

	constructor (
		private commonServerDateService: CommonServerDateService,
	) {}

	transform (date: string, options = {} as any) {
		if (!commonUtilitiesCoreService.hasValue(date)) {
			if (options.useCommonNAToBlankFormatter) {
				return new CommonNAToBlankFormatter().transform(null);
			} else {
				return new CommonNAFormatter().transform(null);
			}
		}

		options.formatType = options.formatType || 'Medium';

		return upperFirst(this.commonServerDateService.getMomentInstance()(date).format(this.formats[options.formatType]));
	}
}
